﻿import { containerTypeOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("container-type"),
  endpoint: "container-type",
  operations: containerTypeOps,
  baseRoute: "container-type",
  roleView: [ROLE.CONT_TYPE_ADMIN, ROLE.CONT_TYPE_VIEW],
  roleAdmin: [ROLE.CONT_TYPE_ADMIN],
  singularName: (t) => t("Container type"),
  name: (t) => t("Container types"),
});
export default conf;
